export function createScript(url, nonce) {
    const firstElem = document.getElementsByTagName('script')[0];
    const elem = document.createElement('script');
    elem.async = true;
    if (Boolean(nonce)) elem.nonce = nonce;
    elem.src = url;
    firstElem.parentNode.insertBefore(elem, firstElem);
}

export function createTagManger(userSetting = '', nonce) {
    if (userSetting) {
        (function (w, d, s, l, i) {
            w[l] = w[l] || [];
            w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
            var f = d.getElementsByTagName(s)[0],
                j = d.createElement(s),
                dl = l !== 'dataLayer' ? '&l=' + l : '';
            j.async = true;
            if (Boolean(nonce)) j.setAttribute('nonce', nonce);
            j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
            f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', userSetting);
    }
}

export function createCSP(content) {
    const firstElem = document.getElementsByTagName('meta')[0];
    const elem = document.createElement('meta');
    elem.httpEquiv = 'Content-Security-Policy';
    elem.content = content;
    firstElem.parentNode.insertBefore(elem, firstElem);
}
